import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

/*
 * Send form to reset password
 */
export function useResetPassword() {
  const $httpFetch = useHttpFetch()

  async function resetPassword(
    userId: string,
    token: string,
    newPassword: string,
    newPasswordConfirmation: string,
  ) {
    const body = {
      user_id: userId,
      token,
      password: newPassword,
      password_verification: newPasswordConfirmation,
    }

    return $httpFetch('/auth/password-reset/complete-flow', {
      method: 'POST',
      body,
    })
  }

  return { resetPassword }
}
